import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function CGV() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Logo */}
            <div className="flex items-center">
              <Link to="/" className="flex items-center">
                <div className="w-12 h-12 bg-black rounded-lg flex items-center justify-center">
                  <span className="text-white font-bold text-xl" style={{ fontFamily: '"Pacifico", serif' }}>S</span>
                </div>
                <div className="ml-3">
                  <h1 className="text-2xl font-bold text-black leading-tight">Stayk</h1>
                  <p className="text-xs text-gray-600 uppercase tracking-wide">Conciergerie</p>
                </div>
              </Link>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <Link to="/" className="text-gray-600 hover:text-black px-3 py-2 text-sm font-medium whitespace-nowrap">Accueil</Link>
                <Link to="/services" className="text-gray-600 hover:text-black px-3 py-2 text-sm font-medium whitespace-nowrap">Nos Services</Link>
                <Link to="/devis" className="text-gray-600 hover:text-black px-3 py-2 text-sm font-medium whitespace-nowrap">Devis gratuit</Link>
                <Link to="/contact" className="text-gray-600 hover:text-black px-3 py-2 text-sm font-medium whitespace-nowrap">Contact</Link>
                <Link to="/rdv" className="bg-black text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-gray-800 whitespace-nowrap cursor-pointer">Prendre RDV</Link>
              </div>
            </div>

            {/* Mobile menu button */}
            <div className="md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="text-gray-600 hover:text-black focus:outline-none focus:text-black cursor-pointer"
              >
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
                </div>
              </button>
            </div>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <div className="md:hidden">
              <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t border-gray-100">
                <Link to="/" className="text-gray-600 hover:text-black block px-3 py-2 text-base font-medium whitespace-nowrap">Accueil</Link>
                <Link to="/services" className="text-gray-600 hover:text-black block px-3 py-2 text-base font-medium whitespace-nowrap">Nos Services</Link>
                <Link to="/devis" className="text-gray-600 hover:text-black block px-3 py-2 text-base font-medium whitespace-nowrap">Devis gratuit</Link>
                <Link to="/contact" className="text-gray-600 hover:text-black block px-3 py-2 text-base font-medium whitespace-nowrap">Contact</Link>
                <Link to="/rdv" className="bg-black text-white block px-3 py-2 rounded-lg text-base font-medium hover:bg-gray-800 whitespace-nowrap cursor-pointer">Prendre RDV</Link>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Section */}
      <section className="bg-gray-50 py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-black mb-6">
            Conditions Générales de Vente
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Conditions applicables aux services de conciergerie StayK
          </p>
        </div>
      </section>

      {/* CGV Content */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            
            {/* Article 1 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-black mb-6">Article 1 - Objet et champ d'application</h2>
              <div className="text-gray-700 space-y-4">
                <p>
                  Les présentes Conditions Générales de Vente (CGV) régissent les relations contractuelles entre StayK, société de conciergerie spécialisée dans la gestion de locations courte durée, et ses clients.
                </p>
                <p>
                  Elles s'appliquent à tous les services proposés par StayK, notamment :
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Gestion complète de locations courte durée (Formule Essentielle)</li>
                  <li>Gestion premium avec services personnalisés (Formule Premium)</li>
                  <li>Services à la carte (ménage, maintenance, accueil voyageurs)</li>
                  <li>Optimisation des annonces et tarification dynamique</li>
                </ul>
              </div>
            </div>

            {/* Article 2 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-black mb-6">Article 2 - Acceptation des conditions</h2>
              <div className="text-gray-700 space-y-4">
                <p>
                  La signature du contrat de prestation ou la validation d'un devis implique l'acceptation pleine et entière des présentes CGV par le client.
                </p>
                <p>
                  StayK se réserve le droit de modifier ces conditions à tout moment. Les modifications prendront effet après notification au client avec un préavis de 30 jours.
                </p>
              </div>
            </div>

            {/* Article 3 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-black mb-6">Article 3 - Services proposés</h2>
              <div className="text-gray-700 space-y-4">
                <h3 className="text-xl font-semibold text-black">3.1 Formule Essentielle</h3>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Création et optimisation d'annonces sur les plateformes</li>
                  <li>Gestion des réservations et communication voyageurs</li>
                  <li>Ménage entre chaque séjour</li>
                  <li>Accueil et remise des clés</li>
                  <li>Tarification : 20% du chiffre d'affaires + frais de ménage</li>
                </ul>

                <h3 className="text-xl font-semibold text-black mt-6">3.2 Formule Premium</h3>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Tous les services de la formule Essentielle</li>
                  <li>Tarification dynamique avancée</li>
                  <li>Services de conciergerie personnalisés</li>
                  <li>Maintenance et petits travaux</li>
                  <li>Reporting détaillé mensuel</li>
                  <li>Tarification : pourcentage négociable selon le bien</li>
                </ul>
              </div>
            </div>

            {/* Article 4 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-black mb-6">Article 4 - Obligations du client</h2>
              <div className="text-gray-700 space-y-4">
                <p>Le client s'engage à :</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Fournir un logement conforme aux normes de sécurité et d'hygiène</li>
                  <li>Équiper le logement selon les standards de location courte durée</li>
                  <li>Déclarer toutes les réservations aux autorités compétentes</li>
                  <li>Respecter la réglementation locale en matière de location courte durée</li>
                  <li>Informer StayK de tout changement concernant le bien</li>
                  <li>Maintenir une assurance responsabilité civile adaptée</li>
                </ul>
              </div>
            </div>

            {/* Article 5 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-black mb-6">Article 5 - Tarification et facturation</h2>
              <div className="text-gray-700 space-y-4">
                <h3 className="text-xl font-semibold text-black">5.1 Modalités de paiement</h3>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Les commissions sont prélevées automatiquement sur les revenus locatifs</li>
                  <li>Le solde est versé au client dans les 48h suivant le départ du voyageur</li>
                  <li>Les frais de ménage sont facturés séparément selon tarif en vigueur</li>
                </ul>

                <h3 className="text-xl font-semibold text-black mt-6">5.2 Frais supplémentaires</h3>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Interventions d'urgence : 50€ HT par intervention</li>
                  <li>Ménage approfondi après dégradation : selon devis</li>
                  <li>Remplacement d'équipements : au coût réel + 10% de gestion</li>
                </ul>
              </div>
            </div>

            {/* Article 6 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-black mb-6">Article 6 - Responsabilité et assurance</h2>
              <div className="text-gray-700 space-y-4">
                <p>
                  StayK souscrit une assurance responsabilité civile professionnelle couvrant ses activités de gestion locative.
                </p>
                <p>
                  La responsabilité de StayK est limitée aux dommages directs et ne peut excéder le montant des commissions perçues sur les 12 derniers mois.
                </p>
                <p>
                  Le client reste responsable de son bien et doit maintenir une assurance propriétaire non-occupant adaptée à la location courte durée.
                </p>
              </div>
            </div>

            {/* Article 7 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-black mb-6">Article 7 - Durée et résiliation</h2>
              <div className="text-gray-700 space-y-4">
                <h3 className="text-xl font-semibold text-black">7.1 Durée du contrat</h3>
                <p>
                  Le contrat est conclu pour une durée indéterminée avec une période d'engagement minimum de 6 mois.
                </p>

                <h3 className="text-xl font-semibold text-black mt-6">7.2 Résiliation</h3>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Résiliation possible par chaque partie avec préavis de 2 mois</li>
                  <li>Résiliation immédiate en cas de manquement grave aux obligations</li>
                  <li>Les réservations en cours sont honorées jusqu'à leur terme</li>
                </ul>
              </div>
            </div>

            {/* Article 8 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-black mb-6">Article 8 - Protection des données</h2>
              <div className="text-gray-700 space-y-4">
                <p>
                  StayK s'engage à respecter la réglementation en vigueur concernant la protection des données personnelles (RGPD).
                </p>
                <p>
                  Les données collectées sont utilisées uniquement dans le cadre de la prestation de services et ne sont pas transmises à des tiers sans autorisation.
                </p>
                <p>
                  Le client dispose d'un droit d'accès, de rectification et de suppression de ses données personnelles.
                </p>
              </div>
            </div>

            {/* Article 9 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-black mb-6">Article 9 - Force majeure</h2>
              <div className="text-gray-700 space-y-4">
                <p>
                  StayK ne pourra être tenue responsable de l'inexécution de ses obligations en cas de force majeure ou d'événements indépendants de sa volonté.
                </p>
                <p>
                  Sont notamment considérés comme cas de force majeure : pandémie, restrictions gouvernementales, catastrophes naturelles, grèves, pannes informatiques majeures.
                </p>
              </div>
            </div>

            {/* Article 10 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-black mb-6">Article 10 - Litiges et droit applicable</h2>
              <div className="text-gray-700 space-y-4">
                <p>
                  Les présentes CGV sont soumises au droit français. En cas de litige, les parties s'efforceront de trouver une solution amiable.
                </p>
                <p>
                  À défaut d'accord amiable, tout litige sera porté devant les tribunaux compétents de Paris.
                </p>
                <p>
                  Le client peut également recourir à la médiation de la consommation via la plateforme officielle : 
                  <a href="https://www.economie.gouv.fr/mediation-conso" className="text-yellow-600 hover:text-yellow-700 ml-1">
                    www.economie.gouv.fr/mediation-conso
                  </a>
                </p>
              </div>
            </div>

            {/* Contact */}
            <div className="bg-gray-50 p-8 rounded-xl">
              <h2 className="text-2xl font-bold text-black mb-4">Contact</h2>
              <div className="text-gray-700 space-y-2">
                <p><strong>StayK - Conciergerie</strong></p>
                <p>Email : staykconciergerie@gmail.com</p>
                <p>Téléphone : 06 63 88 04 95</p>
                <p>Zone d'intervention : Île-de-France</p>
              </div>
              <p className="text-sm text-gray-600 mt-4">
                Dernière mise à jour : Décembre 2024
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center mr-3">
                  <span className="text-black font-bold text-lg" style={{ fontFamily: '"Pacifico", serif' }}>S</span>
                </div>
                <div>
                  <span className="text-xl font-bold">Stayk</span>
                  <p className="text-xs text-gray-400 uppercase tracking-wide">Conciergerie</p>
                </div>
              </div>
              <p className="text-gray-400 mb-4">
                Votre partenaire de confiance pour la gestion de vos locations courte durée en Île-de-France.
              </p>
              <div className="flex space-x-4">
                <a href="#" className="text-gray-400 hover:text-white cursor-pointer">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-facebook-fill text-xl"></i>
                  </div>
                </a>
                <a href="#" className="text-gray-400 hover:text-white cursor-pointer">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-instagram-line text-xl"></i>
                  </div>
                </a>
                <a href="#" className="text-gray-400 hover:text-white cursor-pointer">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-linkedin-fill text-xl"></i>
                  </div>
                </a>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Services</h3>
              <ul className="space-y-2">
                <li><Link to="/services" className="text-gray-400 hover:text-white cursor-pointer">Formule Essentielle</Link></li>
                <li><Link to="/services" className="text-gray-400 hover:text-white cursor-pointer">Formule Premium</Link></li>
                <li><Link to="/services" className="text-gray-400 hover:text-white cursor-pointer">Services à la carte</Link></li>
                <li><Link to="/zone" className="text-gray-400 hover:text-white cursor-pointer">Zone d'intervention</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Contact</h3>
              <ul className="space-y-2">
                <li><Link to="/devis" className="text-gray-400 hover:text-white cursor-pointer">Devis gratuit</Link></li>
                <li><Link to="/rdv" className="text-gray-400 hover:text-white cursor-pointer">Prendre RDV</Link></li>
                <li><Link to="/contact" className="text-gray-400 hover:text-white cursor-pointer">Nous contacter</Link></li>
                <li className="text-gray-400">Lun-Ven 9h-19h</li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Informations</h3>
              <ul className="space-y-2">
                <li><Link to="/mentions-legales" className="text-gray-400 hover:text-white cursor-pointer">Mentions légales</Link></li>
                <li><Link to="/cgv" className="text-gray-400 hover:text-white cursor-pointer">CGV</Link></li>
                <li><a href="#" className="text-gray-400 hover:text-white cursor-pointer">Confidentialité</a></li>
                <li><a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-white cursor-pointer">Website Builder</a></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-8 pt-8 text-center">
            <p className="text-gray-400">
              © 2024 Stayk Conciergerie. Tous droits réservés. Conciergerie en Île-de-France.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}